/* eslint-disable no-nested-ternary, react/destructuring-assignment, react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Tune } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import {
	Button,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Fade,
	Badge,
	Box
} from '@material-ui/core';

import Sort from '../../sort/Sort';
import DateRangeSelector from '../../../../DateRangeSelector';

export default function ProductAttributesFilterModal(props) {
	const [showModal, setShowModal] = useState(false);
	const theme = useTheme();
	const {
		displayAttribute,
		width,
		filterAttributes,
		filterValues,
		displayFilters,
		setCustomAttributeMap,
		productAttributes
	} = props;
	const customAttributes = displayFilters || [];
	const badgeFilterValues = filterValues
		? Object.fromEntries(Object.entries(filterValues).filter(([key, value]) => {
			const filterInModal = customAttributes.filter((el) => el.uniqueName === key.replace('filterValue', ''));
			return value !== null && filterInModal.length;
		}))
		: {};
	const badgeFilterAttributes = filterAttributes
		? Object.keys(filterAttributes).filter((key) => {
			const filterInModal = customAttributes
				.filter((el) => `${el.section}.${el.uniqueName}` === key || el.uniqueName === key);
			return filterInModal.length;
		})
		: {};

	if (productAttributes && productAttributes.customAttributes && productAttributes.customAttributes.length) {
		setCustomAttributeMap();
		productAttributes.customAttributes.map((customAttribute) => (
			setCustomAttributeMap(customAttribute)
		));
	}

	const toggleModal = () => {
		setShowModal(!showModal);
	};

	const ModalBody = customAttributes.map((attribute) => {
		if (attribute && attribute.isFiltered) {
			const {
				uniqueName, name, pickListElements
			} = attribute;
			if (uniqueName === 'location' || (name === 'Category' && pickListElements && !pickListElements.length)) {
				return null;
			}
			return (
				<div style={{ marginBottom: '10px' }} key={attribute.uniqueName} data-cy={attribute.name}>
					{attribute.name}
					:
					{' '}
					{displayAttribute(attribute)}
				</div>
			);
		}
		return null;
	});

	return (
		displayFilters.length ? (
			<div style={{ paddingRight: width !== 'xs' ? '10px' : '0px' }}>
				{width !== 'xs'
					? (
						<Badge
							badgeContent={
								Object.keys(badgeFilterValues).length + Object.keys(badgeFilterAttributes).length
							}
							color="secondary"
							style={{ marginRight: '10px' }}
						>
							<Button
								color={
									Object.keys(badgeFilterValues).length || Object.keys(badgeFilterAttributes).length
										? 'secondary' : 'primary'
								}
								size="small"
								aria-label="open filters"
								variant="outlined"
								onClick={toggleModal}
								style={{ outline: 0, padding: '5px 8px', marginLeft: '5px' }}
							>
								<Tune style={{ marginRight: '5px' }} />
								More Filters
							</Button>
						</Badge>
					)
					: (
						<Badge
							badgeContent={
								Object.keys(badgeFilterValues).length + Object.keys(badgeFilterAttributes).length
							}
							color="secondary"
							overlap="circular"
						>
							<IconButton
								color="inherit"
								aria-label="open filters"
								edge="start"
								onClick={toggleModal}
								style={{ outline: 0, padding: '5px', margin: '0px' }}
								data-cy="mobileFilterButton"
							>
								<Tune
									style={{ fontSize: '30px' }}
									color={
										Object.keys(badgeFilterValues).length
										|| Object.keys(badgeFilterAttributes).length ? 'secondary' : 'primary'
									}
								/>
							</IconButton>
						</Badge>
					)}
				<Dialog
					open={showModal}
					onClose={toggleModal}
					PaperProps={{ style: { borderRadius: 10, minWidth: '300px', padding: '20px' } }}
					TransitionComponent={Fade}
					scroll="paper"
				>
					<DialogTitle style={{ padding: '0px 8px' }}>Filters</DialogTitle>
					<DialogContent style={{ padding: '8px' }}>
						{width === 'xs'
							? (
								<Box
									display="flex"
									style={
										{ justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }
									}
								>
									<DateRangeSelector
										callback={props.callback}
										pageActiveCallback={props.pageActiveCallback}
										searchParams={props.searchParams}
										showTriggerButton={props.showTriggerButton}
										searchComponents={props.searchComponents}
									/>
									<Sort {...props} />
								</Box>
							)
							: null}
						{ ModalBody }
					</DialogContent>
					<DialogActions disableSpacing style={{ justifyContent: 'space-around' }}>
						<Button variant="contained" color="primary" onClick={toggleModal}>Close</Button>
						<Button
							variant="contained"
							style={{ color: 'white', backgroundColor: theme.palette.error.main }}
							onClick={() => { props.resetFilter(); toggleModal(); }}
						>
							Clear All
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		) : null
	);
}
